module.exports = __webpack_public_path__ + "img/lens-150-plus-02.342b2105.png";